import { render, staticRenderFns } from "./SupportPopup.vue?vue&type=template&id=b73f2440&scoped=true"
import script from "./SupportPopup.vue?vue&type=script&lang=js"
export * from "./SupportPopup.vue?vue&type=script&lang=js"
import style0 from "./SupportPopup.vue?vue&type=style&index=0&id=b73f2440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73f2440",
  null
  
)

export default component.exports